import { Map as ImmutableMap } from 'immutable';
export default ImmutableMap({
  privacy_consent_approve: {
    id: 'privacy_consent_approve',
    label: 'customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.options.approve'
  },
  privacy_consent_decline: {
    id: 'privacy_consent_decline',
    label: 'customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.options.decline'
  },
  privacy_consent_revoke: {
    id: 'privacy_consent_revoke',
    label: 'customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.privacyConsent.options.revoke'
  }
});